module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/iterators.js
// module id = 262
// module chunks = 1